import _process from "process";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var process = _process;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEnv = getEnv;

  function getEnv(defaultValue = "development") {
    return process.env.BABEL_ENV || "production" || defaultValue;
  }

  return exports;
}